import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Reusable action button with icon and tooltip
 * Optimized to guarantee a 48x48px touch target for WCAG 2.5.5 compliance
 */
const ActionButton = ({ 
  icon, 
  tooltipTitle, 
  onClick, 
  ariaLabel, 
  ...props 
}) => (
  <Tooltip title={tooltipTitle}>
    <IconButton 
      onClick={onClick} 
      aria-label={ariaLabel || tooltipTitle}
      sx={{
        width: 48,
        height: 48,
        padding: '12px', // Standard padding to center a 24px icon inside a 48px box
        transition: 'all 0.2s cubic-bezier(0.2, 0, 0, 1)',
        '&:hover': {
          backgroundColor: (theme) => theme.palette.surfaceContainerHigh,
        },
        ...props.sx
      }}
      {...props}
    >
      {React.cloneElement(icon, { sx: { fontSize: '20px' } })}
    </IconButton>
  </Tooltip>
);

ActionButton.propTypes = {
  icon: PropTypes.element.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool
};

export default ActionButton;